import { cva, type VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

const alertVariants = cva(
  'relative flex w-full gap-3 rounded-card border p-3 text-sm [&>svg]:size-4 [&>svg]:shrink-0 [&>svg]:translate-y-0.5',
  {
    variants: {
      tone: {
        info: 'border-border-subtle bg-brand-fill-subtle text-body [&>svg]:text-brand-text',
        success: 'border-success-border bg-success-subtle text-body [&>svg]:text-success-text',
        warning: 'border-warning-border bg-warning-subtle text-body [&>svg]:text-warning-text',
        danger: 'border-danger-border bg-danger-subtle text-body [&>svg]:text-danger-text',
      },
    },
    defaultVariants: {
      tone: 'info',
    },
  },
)

export type AlertProps = ComponentProps<'div'> & VariantProps<typeof alertVariants>

export function Alert({ className, tone, ...props }: AlertProps) {
  return <div role="alert" className={cn(alertVariants({ tone }), className)} {...props} />
}

export function AlertTitle({ className, ...props }: ComponentProps<'p'>) {
  return <p className={cn('font-semibold text-heading', className)} {...props} />
}

export function AlertDescription({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('text-sm text-body', className)} {...props} />
}
